/** @file DEPTH_RANGE: near and far planes of the orthographic camera and its distance from the target. */

/** The camera sits `distance` units toward the viewer from its target; depth is clipped to [near, far] from it. */
export const DEPTH_RANGE = { near: 0.1, far: 200, distance: 50 } as const;
